export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Stitching Icon.020bef91.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};